// Ledger Gift Card Banner
export const GIFT_CARD_BANNER_TEXTS = {
    TITLE: "Share love through e-gift vouchers!",
    SUBTITLE: "Celebrate special occasions with your loved ones with e-gift vouchers.",
    CTA_TEXT: "Buy a gift voucher",
};

export const GIFT_CARD_BANNER_ICON = "portal/m/sm_gifting/generic_gifting_ledger.png";

// Gift Selection Page
export const OTHER = "Other";
export const OTHER_AMOUNT = -1;
export const MOST_POPULAR_TAG = "POPULAR";

export const AMOUNT_SELECTION_WIDGET_TEXTS = {
    TITLE: "Choose an amount",
    SUBTITLE: "Get {0}% off on ₹{1} and above",
};

export const MESSAGE_CONTAINER_INPUT_TITLE = "Add a message (optional)";

export const FAQ_CTA_TEXT = "FAQ";

export const DATE_OF_PURCHASE = "Date Of Purchase : {0}";
export const CARD_AMOUNT = "Card amount : {0}";
export const AMOUNT_PAID = "Amount paid : {0}";
export const PAYMENT_MODE = "Payment mode : {0}";
export const EXPIRY_MESSAGE = "Expires on : 28th February, 2026";

export const CLAIM_SCREEN_TEXTS = {
    SUBTEXT: "You’ve received a Swiggy gift voucher!",
    CLAIM: "Claim Swiggy Money",
};

export const GIFT_CARD_DELIGHT_SCREEN_BANNER_URL = "portal/m/sm_gifting/delight_screen_icon.png";

export const SENDER_TEXT = "- from, {0}";
